import { connect } from 'react-redux'
import CadastroCredencialModal from './modal';

export default connect()(CadastroCredencialModal);
